import { useDateHook } from '../../../hook/useDateHook';
import { NumberTicket } from '../../ticket/NumberTicket';
import { QrTicket } from '../../ticket/QrTicket';

type TicketProps = {
  isMainEvent?: boolean;
};

export const Ticket = ({ isMainEvent = true }: TicketProps) => {
  const { showQrDate } = useDateHook();

  if (showQrDate(isMainEvent)) return <QrTicket isMainEvent={isMainEvent} />;
  return <NumberTicket isMainEvent={isMainEvent} />;
};
